import React from 'react';
import PropTypes from 'prop-types';
import { isValid, decodeTags, removeTags, isText, decodeSpecialCharacters } from '../../../../utils';
import './article-grid.scss';
import { SITE_HOST } from '../../../../consts';
import Button from '../../../common/Button';

const ArticleGrid = ({ data, isMobile }) => {
  if (!isValid(data)) {
    return null;
  }

  const articleValues = Object.entries(data);

  let heading;
  let featuredStory;
  let specificContent;
  let articleGrid = [];
  articleValues.map(([articleName, article]) => {
    if (!isValid(article)) return null;

    if (articleName === 'heading') {
      heading = removeTags(decodeTags(article));
    } else if (articleName === 'specificContent') {
      specificContent = article;
    } else if (articleName === 'bodyText') {
      return;
    } else {
      if (articleName === 'featuredStoryOne') {
        const {
          author_name,
          featuredArticleUrl,
          featuredArticleText,
          image,
          bodyText,
          bodyTextDefault,
          buttonOverride,
          imageCredit,
        } = article;
        const { imageSrc, imageSrcMobile, imageAlt } = image;
        const bodyTextDecoded = decodeSpecialCharacters(bodyText).trim();
        const selectedBodyText = (isText(bodyText) && bodyTextDecoded !== '<p></p>') ? bodyText : bodyTextDefault;
        const buttonText = (isText(buttonOverride)) ? buttonOverride : 'Read More';
        const button = (isValid(buttonText) && isValid(featuredArticleUrl)) ? { text: buttonText, url: featuredArticleUrl } : null;
        featuredStory = (
          <div className={articleName} key={articleName}>
            <div className="featured-story-image-container">
              <span className="img-credit">{imageCredit}</span>
              <a href={featuredArticleUrl} target='_blank'>
                <img src={imageSrc} alt={imageAlt} />
              </a>
            </div>
            <div className='featured-story-text-container'>
              <div className='featured-story-text'>
                <p className='author-name'>By: {author_name}</p>
                <h3>
                  <a href={featuredArticleUrl} target='_blank'>{featuredArticleText}</a>
                </h3>
                {specificContent && (
                  <>
                    <div className='body-text' dangerouslySetInnerHTML={{ __html: selectedBodyText }}></div>
                    <div class='button-wrapper'>
                      <Button button={button} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        const { author, url, text, image } = article;
        const { topcard, topcardMobile, imageAlt } = image;
        articleGrid.push(
          <div className={articleName} key={articleName}>
            <div className="featured-story-image-container">
              <a href={SITE_HOST + '/' + url} target='_blank'>
                <img src={topcard} alt={imageAlt} />
              </a>
            </div>
            <div className='article-text'>
              <p>by {author}</p>
              <h3>
                <a href={SITE_HOST + '/' + url} target='_blank'>{text}</a>
              </h3>
              {specificContent && (
                <a className='read-more' href={SITE_HOST + '/' + url} target='_blank'>
                  read more
                </a>
              )}
            </div>
          </div>
        );
      }
    }
  });

  return (
    <div className={`article-grid-container ${specificContent ? 'specific-content' : 'normal'}`}>
      {(isValid(heading) && heading.trim() !== "") && 
        <>
          <h2 className='article-grid-title'>{heading}</h2>
          {!specificContent && <div className='hr-rule'></div>}
        </>
      }
      <div className='articles'>
        {featuredStory}
        <div className='article-grid'>{articleGrid}</div>
      </div>
    </div>
  );
};

ArticleGrid.propTypes = {
  data: PropTypes.array,
};

export default ArticleGrid;
